import React, { Component } from "react";
import { CRUDFunction } from "./../../../reduxCURD/container";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
// import { Label } from './../../Common/Forms/formsMiscItems';
import _ from "lodash";
import { ModalStyles } from "./../../Common/styles.js";
import MaintenanceImageArea from "./MaintenanceImageArea";
import { getAppMockupsTypes } from "./../../../reduxRelated/actions/diagnosticsActions";
import "components/Common/commonform.css";
import { checkFormIsValid, processFromFields } from "../../../utils/helpers";
import FormFields, { FormFieldHelpers } from "../../../wigets/forms/formFields";
import ImageGallery from "./../../Common/ImageGallery";
import { languageService } from "../../../Language/language.service";
import DocumentGallery from "components/Common/DocumentGallery/index";
import {
  FormModels,
  historyFields,
  LOCATION_TYPES,
  locationGPSFields,
  locationMarkerTemplateFields,
  locationMilepostFields,
  maintenanceAddFields,
  MaintenanceViewOnlyFields,
  maintenanceEditFields,
} from "./variables";
import SvgIcon from "react-icons-kit";
import { plus } from "react-icons-kit/icomoon/plus";
import { minus } from "react-icons-kit/icomoon/minus";
import { getAssetLines, getAssetLinesWithSelf } from "../../../reduxRelated/actions/assetHelperAction";
// import MaintenanceDocumentsArea from "./MaintenanceDocumentsArea";
import DocumentsArea from "components/Common/DocumentsArea/index";
import { FORM_MODES } from "../../../utils/globals";
import ImageSlider from "../../Common/ImageSlider";
import { CommonModalStyle, ButtonStyle } from "style/basic/commonControls";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import EstimateListEditable from "./EstimateListEditable";
import { commonPageStyle } from "../../Common/Summary/styles/CommonPageStyle";
import permissionCheck from "../../../utils/permissionCheck";
import { curdActions } from "reduxCURD/actions";
import moment from "moment";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import {
  arrayToTree,
  filterTreeByProperties,
  findTreeNode,
  groupTreeNodeByProperty,
  loadTreeObjects,
  oneLayerTreeItemsToObjects,
  treeToArray,
  treeToPropertiesObject,
} from "../../../utils/treeData";

const MyButton = (props) => (
  <button className="setPasswordButton" {...props}>
    {props.children}
  </button>
);

class AddMaintenance extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.updateFrom = this.updateFrom.bind(this);
    this.handleImageSliderClose = this.handleImageSliderClose.bind(this);
    this.updateEstimate = this.updateEstimate.bind(this);
    this.toggleConfirmMRChange = this.toggleConfirmMRChange.bind(this);
    this.handleConfirmationChangeMRResponse = this.handleConfirmationChangeMRResponse.bind(this);

    this.state = {
      maintenanceFields: _.cloneDeep(maintenanceAddFields),
      maintenanceViewOnlyFields: _.cloneDeep(MaintenanceViewOnlyFields),
      locationGPSFields: null,
      locationMilepostFields: _.cloneDeep(locationMilepostFields),
      locationMarkerFields: null,
      historyFields: null,

      locationType: 0,

      imageList: [], //['test.jpg', 'test.jpg', 'test.jpg', 'test.jpg', 'test.jpg', 'test.jpg', 'test.jpg'],
      imgSlider: false,
      selectedImageIndex: 0,
      documentList: [],

      // modalState: "None",
      formModes: FORM_MODES.BASE,
      isHistoryData: false,
      estimateHistoryRecord: [],
      estimate: [],
      confirmCloseMR: {
        status: false,
        dataToSubmit: null,
      },
      isHistoryField: false,
      assets: [],
      locationObj: [],
    };
  }
  componentDidMount() {
    // this.props.getAssetLinesWithSelf();
    this.props.getAsset("/getAssetTreeAndTypes");
  }
  componentDidUpdate(prevProps, prevState) {
    //1- Data load and model not load ( when model open it runs)
    //2- Data not load and model load ( without data it will not run)

    // net result : both should be loaded before processing form.
    if (this.props.assetActionType === "ASSET_READ_SUCCESS" && prevProps.assetActionType !== this.props.assetActionType) {
      let locationObj = [];
      if (this.props.asset) {
        const assetsTrees = this.props.asset.assetTree;
        const assetTypes = this.props.asset.assetsTypes;
        const Allassets = treeToPropertiesObject(assetsTrees);
        if (Allassets.length) {
          locationObj = Allassets.filter((item) => item && item.location === true && item.plannable == true);
          let inspectableAssets = Allassets.filter((item) => item && item.location === false);
          if (locationObj.length > 0) {
            this.setState({ assets: inspectableAssets, locationObj: locationObj, assetTypes: assetTypes, assetsTree: assetsTrees });
            this.props.modal && this.formLoad(locationObj, inspectableAssets, assetsTrees);
          }
        }
      }
    }
    if (prevProps.modal !== this.props.modal && this.props.modal) {
      this.formLoad(this.state.locationObj, this.state.assets, this.state.assetsTree);
    }
  }

  deleteDocumentHandle = (docName, index) => {
    this.setState(({ documentList }) => ({ documentList: documentList.filter((doc, i) => i !== index) }));
  };

  formLoad(locationObj, assets, assetsTree) {
    let mafs = _.cloneDeep(maintenanceAddFields);
    mafs.maintenanceType.config.options = this.props.maintenanceTypes.map((mt) => {
      return { val: mt, text: mt };
    });
    mafs.maintenanceType.value = mafs.maintenanceType.config.options[0].val;

    mafs.maintenanceType.valid = true;

    if (locationObj.length > 0) {
      let data = locationObj.map((ln) => {
        return { val: ln._id.toString(), text: ln.unitId };
      });
      mafs.lineId.config.options = data;
    }

    if (this.props.modalState === "Edit") {
      this.mapSelectedMaintenanceToFields(mafs, assetsTree);
    } else {
      let locationMPFields = _.cloneDeep(locationMilepostFields);
      let locationMarkerFields = _.cloneDeep(locationMarkerTemplateFields);

      let firstAsset = null;
      if (assets.length > 0) {
        let inspectableAssets = this.getAssetsListForLineId(mafs.lineId.config.options[0].val, assetsTree);
        mafs.asset.config.options = inspectableAssets.map((asset, index) => {
          if (index == 0) {
            firstAsset = asset;
          }
          return { val: asset._id, text: asset.unitId };
        });
      }
      if (firstAsset) {
        mafs.lineId.value = mafs.lineId.config.options[0].val;
        mafs.asset.value = mafs.asset.config.options[0].val;
        mafs.asset.valid = true;
        mafs.lineId.valid = true;
        if (this.checkIsYardTrack(firstAsset)) {
          this.addLineLimitsToCaptionsAndValidations(firstAsset, locationMarkerFields, true);
          locationMPFields = null;
        } else {
          locationMarkerFields = null;
          this.addLineLimitsToCaptionsAndValidations(firstAsset, locationMPFields);
        }
      } else {
        locationMPFields = null;
        locationMarkerFields = null;
      }
      this.setState({
        maintenanceFields: mafs,
        locationGPSFields: null,
        historyFields: null,
        locationMarkerFields: locationMarkerFields,
        locationMilepostFields: locationMPFields,

        imageList: [],
        documentList: [],
        showImgGal: false,
        showDocsGal: false,
        message: "",
        estimate: [],
        estimateHistoryRecord: [],
      });
    }
  }
  mapSelectedMaintenanceToFields = (maintenanceFields, assetsTree) => {
    let { selectedMaintenance } = this.props;
    // let maintenanceViewOnlyFields = _.cloneDeep(MaintenanceViewOnlyFields);
    let disableFields = selectedMaintenance.status === "In Progress" || selectedMaintenance.status === "Closed"; // Do not allow editing maintenance that are in progress or complete. Allow Estimate addition for In progress
    maintenanceFields = {
      ..._.cloneDeep(maintenanceEditFields),
      ...maintenanceFields,
    };

    let historyFieldsTemplate = _.cloneDeep(historyFields);

    for (let key in selectedMaintenance) {
      if (key in maintenanceFields) {
        if (key === "assignedTo") {
          maintenanceFields[key].value = selectedMaintenance[key].id;
          maintenanceFields[key].valid = true;
        } else if (key == "asset") {
          let inspectableAssets = this.getAssetsListForLineId(selectedMaintenance.lineId, assetsTree);
          maintenanceFields.asset.config.options = inspectableAssets.map((asset, index) => {
            return { val: asset._id, text: asset.unitId };
          });
          maintenanceFields.asset.value = selectedMaintenance.asset.id;
        } else if (key == "lineId") {
          maintenanceFields.lineId.value = selectedMaintenance.lineId;
        } else {
          maintenanceFields[key].value = selectedMaintenance[key];
          maintenanceFields[key].valid = true;
        }

        maintenanceFields[key].config["disabled"] |= disableFields; // disable only. Do not enable if already disabled.
      }

      if (key in historyFieldsTemplate) {
        historyFieldsTemplate[key].value = selectedMaintenance[key];
        historyFieldsTemplate[key].valid = true;
      }
    }
    //adding voice notes field data
    maintenanceFields.voiceNotes.value =
      selectedMaintenance.issue && selectedMaintenance.issue.voiceNotes ? selectedMaintenance.issue.voiceNotes : "";
    maintenanceFields["voiceNotes"].config["disabled"] |= disableFields;

    if (selectedMaintenance.sourceType !== "web-issue") {
      maintenanceFields["afeNumber"].config["disabled"] = true;
    }
    if (selectedMaintenance.sourceType === "app-issue") {
      maintenanceFields["voiceNotes"].config["disabled"] = true;
    }

    let isHistoryFields = false;
    for (let key2 in historyFieldsTemplate) {
      if (selectedMaintenance.status !== "New") {
        historyFieldsTemplate[key2].config["disabled"] = true;
        historyFieldsTemplate[key2].valid = true;

        if (!(key2 in selectedMaintenance)) {
          delete historyFieldsTemplate[key2];
        }
      } else {
        if (key2 in selectedMaintenance) isHistoryFields = true;
      }
    }

    if (selectedMaintenance.status === "New" && !isHistoryFields) {
      historyFieldsTemplate = null;
    }

    let locationFields = this.mapLocationFieldsToState(selectedMaintenance.location);
    if (selectedMaintenance.asset && selectedMaintenance.asset.id) {
      // let modifiedAsset = {
      //   ...selectedMaintenance.asset,
      // };
      // let yardTrack = this.checkIsYardTrack(modifiedAsset);
      // if (yardTrack && locationFields.locationMarkerFields) {
      //   /*
      //   markerStart: selectedMaintenance.asset.startMarker,
      //   markerEnd: selectedMaintenance.asset.endMarker,
      //   */

      //   locationFields.locationMarkerFields = this.addLineLimitsToCaptionsAndValidations(
      //     modifiedAsset,
      //     locationFields.locationMarkerFields,
      //     true,
      //   );
      // }
      if (locationFields.locationMilepostFields) {
        // locationFields.locationMilepostFields = this.addLineLimitsToCaptionsAndValidations(
        //   selectedMaintenance.asset,
        //   locationFields.locationMilepostFields,
        // );

        if (selectedMaintenance.status !== "New" && locationFields.locationMilepostFields) {
          locationFields.locationMilepostFields.start.config.disabled = true;
          locationFields.locationMilepostFields.end.config.disabled = true;
        }
      }
    }

    if (disableFields) {
      for (let k3 in locationFields.locationMilepostFields) {
        locationFields.locationMilepostFields[k3].config["disabled"] = disableFields;
      }
    }

    maintenanceFields.lineId.config.disabled = true;
    maintenanceFields.asset.config.disabled = true;

    let imageList = selectedMaintenance.images.map((item) => item.imgName);
    let documentList = selectedMaintenance.documents.map((item) => item);

    if (!locationFields.locationGPSFields) locationFields.locationGPSFields = null;

    this.setState({
      maintenanceFields: maintenanceFields,
      ...locationFields,
      historyFields: historyFieldsTemplate,
      imageList: imageList,
      documentList: documentList,
      estimate: selectedMaintenance.estimate,
      estimateHistoryRecord: selectedMaintenance.estimateHistoryRecord,
    });
  };

  checkIsYardTrack(asset) {
    if (this.state.assetTypes) {
      let found = this.state.assetTypes.find((aType) => aType.assetType === asset.assetType && aType.markerMilepost);
      return found;
    }
  }

  checkIfAppIssue(maintenance) {
    return maintenance && maintenance.sourceType
      ? maintenance.sourceType === "app-issue" || maintenance.sourceType === "manual-app-workorder"
      : false;
  }
  mapLocationFieldsToState = (location) => {
    let gps,
      milepost,
      marker = false;
    let lmpfs = _.cloneDeep(locationMilepostFields);
    let lgpsfs = _.cloneDeep(locationGPSFields);
    let lmrfs = _.cloneDeep(locationMarkerTemplateFields);
    const isAppIssue = this.checkIfAppIssue(this.props.selectedMaintenance);
    let disabled = isAppIssue; // do not allow change in location if the source is app

    if (location.length > 0) {
      location.map((item) => {
        if (item.type === "GPS") {
          gps = true;
          lgpsfs.start_lat.value = item.start.lat;
          lgpsfs.start_lat.valid = true;
          lgpsfs.start_lat.config.disabled = disabled;
          lgpsfs.end_lat.value = item.end.lat;
          lgpsfs.end_lat.valid = true;
          lgpsfs.end_lat.config.disabled = disabled;
          lgpsfs.start_lon.value = item.start.lon;
          lgpsfs.start_lon.valid = true;
          lgpsfs.start_lon.config.disabled = disabled;
          lgpsfs.end_lon.value = item.end.lon;
          lgpsfs.end_lon.valid = true;
          lgpsfs.end_lon.config.disabled = disabled;
        }

        if (item.type === "Milepost") {
          milepost = true;
          lmpfs.start.value = item.start;
          lmpfs.start.valid = true;
          lmpfs.start.touched = false;
          lmpfs.start.config.disabled = disabled;
          lmpfs.end.value = item.end;
          lmpfs.end.valid = true;
          lmpfs.end.touched = false;
          lmpfs.end.config.disabled = disabled;
        }

        if (item.type === "Marker") {
          marker = true;
          lmrfs.start.value = item.start;
          lmrfs.start.valid = true;
          lmrfs.start.touched = false;
          lmrfs.start.config.disabled = disabled;
          lmrfs.end.value = item.end;
          lmrfs.end.valid = true;
          lmrfs.end.touched = false;
          lmrfs.end.config.disabled = disabled;
        }
      });
    }

    let finalObjectToReturn = {
      locationGPSFields: gps ? lgpsfs : null,
      locationMilepostFields: milepost ? lmpfs : null,
      locationMarkerFields: marker ? lmrfs : null,
    };

    return finalObjectToReturn;
  };
  findValueAsset(assetId) {
    if (assetId && this.state.assets.length) {
      let asset =
        this.state.assets.length &&
        this.state.assets.find((a) => {
          return a._id === assetId;
        });
      return asset;
    }
  }
  addLineLimitsToCaptionsAndValidations(asset, locationMilepostFields1, markerCheck) {
    if (locationMilepostFields1) {
      if (markerCheck) {
        locationMilepostFields1.start.value =
          asset.markerStart || asset.markerEnd ? (asset.markerStart ? asset.markerStart : "") : asset.start;
        locationMilepostFields1.end.value = asset.markerStart || asset.markerEnd ? (asset.markerEnd ? asset.markerEnd : "") : asset.end;

        if (!locationMilepostFields1.start.labelText.endsWith(""))
          locationMilepostFields1.start.labelText = `${languageService(locationMilepostFields1.start.labelText)}`;

        if (!locationMilepostFields1.end.labelText.endsWith(""))
          locationMilepostFields1.end.labelText = `${languageService(locationMilepostFields1.end.labelText)}`;

        locationMilepostFields1.start.validation.min = "";
        locationMilepostFields1.start.validation.max = "";

        locationMilepostFields1.end.validation.min = "";
        locationMilepostFields1.end.validation.max = "";

        locationMilepostFields1.start.config.disabled = true;
        locationMilepostFields1.end.config.disabled = true;
      } else {
        let startLimit = asset.start,
          endLimit = asset.end;
        let limitMsg = ": [" + startLimit + " to " + endLimit + "] ";

        if (!locationMilepostFields1.start.labelText.endsWith(limitMsg))
          locationMilepostFields1.start.labelText = `${languageService(locationMilepostFields1.start.labelText)} ${limitMsg}`;

        if (!locationMilepostFields1.end.labelText.endsWith(limitMsg))
          locationMilepostFields1.end.labelText = `${languageService(locationMilepostFields1.end.labelText)} ${limitMsg}`;

        let setDisabled = asset.assetTypeClassify === "point" || asset.start === asset.end;
        if (setDisabled) {
          locationMilepostFields1.start.config.disabled = true;
          locationMilepostFields1.end.config.disabled = true;
        }

        locationMilepostFields1.start.value = asset.start;
        locationMilepostFields1.end.value = asset.end;

        // add validations
        locationMilepostFields1.start.validation.min = asset.start;
        locationMilepostFields1.start.validation.max = asset.end;

        locationMilepostFields1.end.validation.min = asset.start;
        locationMilepostFields1.end.validation.max = asset.end;
      }
    }
    return locationMilepostFields1;
  }

  getAssetsListForLineId(lineId, assetsTree = this.state.assetsTree) {
    if (assetsTree) {
      let lineBranch = findTreeNode(assetsTree, lineId);
      let assetNodes = treeToPropertiesObject(lineBranch);
      let inspectableAssets = assetNodes.filter((item) => item && item.location === false);
      return inspectableAssets;
    }
    return [];
  }

  updateFrom = (newState) => {
    let locationMPfields = _.cloneDeep(locationMilepostFields);
    let locationMarkerFields = _.cloneDeep(locationMarkerTemplateFields);
    if (
      newState.maintenanceFields &&
      newState.maintenanceFields.lineId &&
      newState.maintenanceFields.lineId.value !== this.state.maintenanceFields.lineId.value
    ) {
      let assetsList = this.getAssetsListForLineId(newState.maintenanceFields.lineId.value);
      newState.maintenanceFields.asset.config.options = [];
      newState.maintenanceFields.asset.value = "";
      if (assetsList.length > 0) {
        newState.maintenanceFields.asset.config.options = assetsList.map((asset) => {
          return { val: asset._id, text: asset.unitId };
        });
        newState.maintenanceFields.asset.value = assetsList[0]._id; // Update asset value
        this.onAssetChange(newState, locationMPfields, locationMarkerFields);
      } else {
        newState.locationMilepostFields = null;
        newState.locationMarkerFields = null;
      }
    }
    if (this.state.locationMilepostFields) {
      for (let key in locationMPfields) {
        if (
          this.state.locationMilepostFields[key] &&
          this.state.locationMilepostFields[key].value &&
          this.state.locationMilepostFields[key].touched
        ) {
          locationMPfields[key].value = this.state.locationMilepostFields[key].value;
          locationMPfields[key].touched = true;
        }
      }
    }
    if (
      newState.maintenanceFields &&
      newState.maintenanceFields.asset &&
      newState.maintenanceFields.asset.value !== this.state.maintenanceFields.asset.value
    ) {
      this.onAssetChange(newState, locationMPfields, locationMarkerFields);
    }

    this.setState({ ...newState, message: "" });
  };

  onAssetChange(newState, locationMPfields, locationMarkerFields) {
    let asset = this.findValueAsset(newState.maintenanceFields.asset.value);
    if (asset) {
      if (this.checkIsYardTrack(asset)) {
        locationMarkerFields = this.addLineLimitsToCaptionsAndValidations(asset, locationMarkerFields, true);
        locationMPfields = null;
      } else {
        locationMarkerFields = null;
        locationMPfields = this.addLineLimitsToCaptionsAndValidations(asset, locationMPfields);
      }
      newState.locationMilepostFields = locationMPfields;
      newState.locationMarkerFields = locationMarkerFields;
    }
  }

  updateEstimate(updatedState) {
    this.setState(updatedState);
  }

  submitForm = (e) => {
    e.preventDefault();
    let location = [];
    let { maintenanceFields, message, historyFields } = this.state;
    let dataToSubmit = processFromFields(maintenanceFields);
    let formIsValid = checkFormIsValid(maintenanceFields);
    let item = {
      name: "Milepost",
      disabled: false,
      model: locationMilepostFields,
      modelName: "locationMilepostFields",
    };

    if (
      this.state.locationMilepostFields ||
      (this.props.selectedMaintenance && this.props.selectedMaintenance.location.findIndex((ol) => ol.type === "Milepost") !== -1)
    ) {
      location = this.mapLocationStateToSubmitData(location, item);
      processFromFields(this.state["locationMilepostFields"]);
      formIsValid = checkFormIsValid(this.state["locationMilepostFields"]) && formIsValid;
    }

    if (this.state.locationGPSFields) {
      item = { ...item, name: "GPS", model: this.state["locationGPSFields"], modelName: "locationGPSFields" };

      formIsValid = checkFormIsValid(this.state["locationGPSFields"]) && formIsValid;
      location = this.mapLocationStateToSubmitData(location, item);
    }

    if (this.state.locationMarkerFields) {
      item = { ...item, name: "Marker", model: this.state["locationMarkerFields"], modelName: "locationMarkerFields" };

      formIsValid = checkFormIsValid(this.state["locationMarkerFields"]) && formIsValid;
      location = this.mapLocationStateToSubmitData(location, item);
    }

    if (!location) return false;

    this.setFormValidation(this.state["locationMilepostFields"], "locationMilepostFields");
    let asset = this.state.assets.find((asset) => {
      return asset._id === dataToSubmit.asset;
    });

    if (asset) {
      let isYardTrack = this.checkIsYardTrack(asset);
      let markerVals = asset.markerStart || asset.markerEnd ? { startMarker: asset.markerStart, endMarker: asset.markerEnd } : {};
      if (isYardTrack) markerVals.markerMilepost = true;
      dataToSubmit.asset = {
        unitId: asset.unitId,
        id: asset._id,
        start: asset.start,
        end: asset.end,
        assetType: asset.assetType,
        parentAsset: {},
        track_id: "",
        coordinates: [],
        parent_id: "",
        testForm: [],
        attribute: {},
        freeze: false,
        ...markerVals,
      };
      dataToSubmit.lineName = asset.locationName;
    }

    let { imageList, documentList } = this.state;

    let images = imageList.map((image) => {
      return { imgName: image, md5: null, status: 1, tag: "before" };
    });

    images = images.map((image) => {
      const selectedImage =
        this.props.selectedMaintenance && this.props.selectedMaintenance.images.find((item) => item.imgName === image.imgName);

      if (selectedImage && selectedImage.md5) {
        console.log("In md5");
        return selectedImage;
      } else {
        console.log("Not In md5");
        return image;
      }
    });

    let estimate = this.state.estimate || [];
    estimate = estimate.map((est) => {
      delete est.editMode;

      return est;
    });
    let estimateHistoryRecord = this.state.estimateHistoryRecord;
    if (formIsValid) {
      if (this.state.historyFields && Object.keys(this.state.historyFields).length > 0 && this.state.isHistoryField) {
        this.setState({
          confirmCloseMR: {
            status: true,
            dataToSubmit: {
              maintenanceRole: this.props.selectedMaintenance ? this.props.selectedMaintenance.maintenanceRole : "",
              ...dataToSubmit,
              location,
              images,
              documents: documentList,
              estimate,
              estimateHistoryRecord,
              ...processFromFields(this.state.historyFields),
            },
            locationMarkerFields: null,
          },
        });
      } else {
        this.props.addMaintenanceHandler(
          { ...dataToSubmit, location, images, documents: documentList, estimate, estimateHistoryRecord },
          this.props.modalState,
        );
      }
    } else {
      this.setFormValidation(maintenanceFields, "maintenanceFields");
    }
  };

  setFormValidation = (data, stateVarName) => {
    for (let key in data) {
      data[key].touched = true;
      const msg = languageService("Validation failed") + ": ";
      if (!data[key].validationMessage.startsWith(msg)) data[key].validationMessage = msg + data[key].validationMessage;
    }

    this.setState({ [stateVarName]: data });
  };

  mapLocationStateToSubmitData = (location, selectedLocationType, oldLocationObject) => {
    let { message } = this.state;
    if (selectedLocationType.name === "GPS") {
      let gpsObj = {
        type: "GPS",
        start: {},
        end: {},
      };

      for (let key in this.state[selectedLocationType.modelName]) {
        let keys = key.split("_");
        gpsObj[keys[0]][keys[1]] = this.state[selectedLocationType.modelName][key].value;
      }
      location.unshift(gpsObj);
    }
    if (selectedLocationType.name === "Milepost") {
      let milepostObj = {
        type: "Milepost",
      };

      for (let key in this.state[selectedLocationType.modelName]) {
        milepostObj[key] = parseFloat(this.state[selectedLocationType.modelName][key].value).toFixed(2);
      }

      if (parseFloat(milepostObj.start) > parseFloat(milepostObj.end)) {
        this.setState({ message: languageService("Milepost start must be less than or equal to Milepost End") });
        return null;
      }

      location.push(milepostObj);
    }
    if (selectedLocationType.name === "Marker") {
      let markerObj = {
        type: "Marker",
      };

      for (let key in this.state[selectedLocationType.modelName]) {
        markerObj[key] = this.state[selectedLocationType.modelName][key].value
          ? this.state[selectedLocationType.modelName][key].value
          : "N/A";
      }

      location.push(markerObj);
    }

    return location;
  };

  addMaintenanceStateHandler = (newState) => this.setState({ ...newState });

  addSelectedImage = (imgName) => {
    if (imgName) {
      console.log(imgName);
      const { imageList } = this.state;
      this.setState({
        imageList: [...imageList, imgName],
        formModes: FORM_MODES.BASE,
      });
    } else {
      this.setState({
        formModes: FORM_MODES.BASE,
      });
    }
  };

  locationTypeSelectionHandler = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  locationAddHandler = () => {
    const { locationType } = this.state;

    if (!this.state[LOCATION_TYPES[locationType].modelName]) {
      this.setState({ [LOCATION_TYPES[locationType].modelName]: Object.assign({}, LOCATION_TYPES[locationType].model) });
    }
  };

  historyDataHandler = () => {
    this.setState({ historyFields: _.cloneDeep(historyFields), isHistoryField: true });
  };

  handleGPSFieldClose = () => {
    this.setState({ locationGPSFields: null });
  };

  handleHistoryFieldClose = () => {
    this.setState({ historyFields: null, isHistoryField: false });
  };

  addDocumentHandle = () => {
    this.setState(({ formModes }) => ({
      formModes: formModes === FORM_MODES.DOCUMENT_SELECTION ? FORM_MODES.BASE : FORM_MODES.DOCUMENT_SELECTION,
    }));
  };

  addSelectedDocument = (docName) => {
    if (docName) {
      this.setState(({ documentList }) => ({ documentList: [...documentList, docName], formModes: FORM_MODES.BASE }));
    } else {
      this.setState({
        formModes: FORM_MODES.BASE,
      });
    }
  };

  handleImageSliderClose() {
    this.setState({
      formModes: FORM_MODES.BASE,
    });
  }

  toggleConfirmMRChange() {
    let confirmCloseMR = this.state.confirmCloseMR;
    if (confirmCloseMR.status) {
      this.setState({
        confirmCloseMR: {
          status: false,
          dataToSubmit: null,
        },
      });
    } else {
      confirmCloseMR.status = !confirmCloseMR.status;
      this.setState({ confirmCloseMR });
    }
  }

  handleConfirmationChangeMRResponse = (response) => {
    if (response) {
      let dataToSubmit = this.state.confirmCloseMR.dataToSubmit;
      let workOrderNumber = "";
      let closedDate = "";
      dataToSubmit.executionDate = dataToSubmit.executionDate ? dataToSubmit.executionDate : moment();

      if (this.props.modalState === "Add") {
        workOrderNumber = moment(dataToSubmit.executionDate).year();
        closedDate = dataToSubmit.executionDate;
      } else if (this.props.modalState === "Edit") {
        workOrderNumber = this.props.selectedMaintenance.workOrderNumber
          ? this.props.selectedMaintenance.workOrderNumber
          : moment(dataToSubmit.executionDate).year();
        closedDate = this.props.selectedMaintenance.closedDate ? this.props.selectedMaintenance.closedDate : dataToSubmit.executionDate;
      }

      dataToSubmit.workOrderNumber = workOrderNumber;
      dataToSubmit.closedDate = closedDate;

      this.props.addMaintenanceHandler(dataToSubmit, this.props.modalState);
    }

    this.setState({
      confirmCloseMR: {
        status: false,
        dataToSubmit: null,
      },
    });
  };

  render() {
    const { selectedMaintenance } = this.props;
    const { maintenanceViewOnlyFields } = this.state;
    return (
      <Modal
        contentClassName={themeService({ default: this.props.className, retro: "retroModal", electric: "electricModal" })}
        isOpen={this.props.modal}
        toggle={this.props.toggle}
        style={{ maxWidth: "98vw" }}
      >
        <ModalHeader style={(ModalStyles.modalTitleStyle, themeService(CommonModalStyle.header))}>
          {this.props.modalState === "Add" ? languageService("Add New Work Order") : languageService("Edit Work Order")}
        </ModalHeader>
        <ModalBody style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>
          <ConfirmationDialog
            modal={this.state.confirmCloseMR.status}
            toggle={this.toggleConfirmMRChange}
            handleResponse={this.handleConfirmationChangeMRResponse}
            confirmationMessage={
              <div>
                <div>
                  <strong>{languageService("Note")}: </strong>
                  {languageService("This MR has been marked as historical. Saving now will close this MR and cannot be changed later")}.
                  <div>{languageService("Do you want to proceed")} ?</div>
                </div>
              </div>
            }
            headerText={languageService("Confirm MR To Historical")}
          />

          {(this.state.formModes === FORM_MODES.BASE || this.state.formModes === FORM_MODES.IMAGE_GALLERY) && (
            <Row>
              <Col md={2}>
                <MaintenanceImageArea imagesList={this.state.imageList} addMaintenanceStateHandler={this.addMaintenanceStateHandler} />
                {/* <MaintenanceDocumentsArea documentList={this.state.documentList} addDocument={this.addDocumentHandle} deleteDocument={this.deleteDocumentHandle} /> */}
                <DocumentsArea
                  documentList={this.state.documentList}
                  addDocument={this.addDocumentHandle}
                  deleteDocument={this.deleteDocumentHandle}
                />
              </Col>
              <Col md={5}>
                <ModalHeader style={ModalStyles.modalTitleStyle}>{languageService("Work Order Attributes")} </ModalHeader>
                <div className={"commonform"}>
                  <FormFields maintenanceFields={this.state.maintenanceFields} fieldTitle={"maintenanceFields"} change={this.updateFrom} />
                  {this.props.modalState === "Edit" && this.checkIfAppIssue(selectedMaintenance) ? <FormFields /> : null}
                </div>
              </Col>
              <Col md={5}>
                <ModalHeader style={ModalStyles.modalTitleStyle}>{languageService("Location Attributes")} </ModalHeader>
                <div className={"commonform"}>
                  <div>
                    <FormFields
                      locationMilepostFields={this.state.locationMilepostFields}
                      fieldTitle={"locationMilepostFields"}
                      change={this.updateFrom}
                    />
                    {this.state.message && (
                      <div style={{ marginTop: "5px", marginBottom: "5px", fontSize: "12px", color: "rgb(157, 7, 7)" }}>
                        <span>{this.state.message}</span>
                      </div>
                    )}
                  </div>

                  {this.state.locationGPSFields && (
                    <div style={{ position: "relative" }}>
                      <SvgIcon
                        style={{ position: "absolute", right: 0, zIndex: 999 }}
                        icon={minus}
                        size={20}
                        onClick={this.handleGPSFieldClose}
                      />
                      <br></br>
                      <FormFields
                        locationGPSFields={this.state.locationGPSFields}
                        fieldTitle={"locationGPSFields"}
                        change={this.updateFrom}
                      />
                    </div>
                  )}

                  {this.state.locationMarkerFields && (
                    <div style={{ position: "relative" }}>
                      {/*<SvgIcon*/}
                      {/*style={{ position: "absolute", right: 0, zIndex: 999 }}*/}
                      {/*icon={minus}*/}
                      {/*size={20}*/}
                      {/*onClick={this.handleGPSFieldClose}*/}
                      {/*/>*/}
                      <br></br>
                      <FormFields
                        locationMarkerFields={this.state.locationMarkerFields}
                        fieldTitle={"locationMarkerFields"}
                        change={this.updateFrom}
                      />
                    </div>
                  )}

                  {this.state.historyFields && (
                    <div style={{ position: "relative" }}>
                      {(this.props.modalState === "Add" || this.state.isHistoryField) && (
                        <SvgIcon
                          style={{ position: "absolute", right: 0, zIndex: 999 }}
                          icon={minus}
                          size={20}
                          onClick={this.handleHistoryFieldClose}
                        />
                      )}

                      <br></br>
                      <FormFields historyFields={this.state.historyFields} fieldTitle={"historyFields"} change={this.updateFrom} />
                    </div>
                  )}
                </div>

                <Row>
                  <Col md={12}>
                    {!this.state.locationGPSFields && (
                      <Row>
                        <Col md={12}>
                          <div
                            style={themeService({
                              default: { padding: "15px 0px", margin: "auto", width: "50%", color: "var(--first)", cursor: "pointer" },
                              retro: {
                                padding: "15px 0px",
                                margin: "auto",
                                width: "50%",
                                color: "var(--second)",
                                cursor: "pointer",
                                float: "right",
                                textAlign: "right",
                              },
                              electric: {
                                padding: "15px 0px",
                                margin: "auto",
                                width: "50%",
                                color: electricColors.second,
                                cursor: "pointer",
                                float: "right",
                                textAlign: "right",
                              },
                            })}
                          >
                            <span
                              style={{
                                verticalAlign: "top",
                                display: "inline-block",
                                marginRight: "10px",
                              }}
                            >
                              {languageService("Add")} GPS
                            </span>
                            <SvgIcon icon={plus} size={20} onClick={this.locationAddHandler} />
                          </div>
                        </Col>

                        {/*<Col md={12}>*/}
                        {/*<div>*/}
                        {/*<select*/}
                        {/*style={themeService(formFeildStyle.inputStyle)}*/}
                        {/*value={this.state.locationType}*/}
                        {/*name={"locationType"}*/}
                        {/*onChange={this.locationTypeSelectionHandler}*/}
                        {/*>*/}
                        {/*{LOCATION_TYPES.map((item, index) => (*/}
                        {/*<option key={index} value={index} disabled={item.disabled}>*/}
                        {/*{item.name}*/}
                        {/*</option>*/}
                        {/*))}*/}
                        {/*</select>*/}
                        {/*</div>*/}
                        {/*</Col>*/}
                      </Row>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {!this.state.historyFields && (
                      <Row>
                        <Col md={12}>
                          <div
                            style={themeService({
                              default: { padding: "15px 0px", margin: "auto", width: "50%", color: "var(--first)", cursor: "pointer" },
                              retro: {
                                padding: "15px 0px",
                                margin: "auto",
                                width: "50%",
                                color: "var(--second)",
                                cursor: "pointer",
                                float: "right",
                                textAlign: "right",
                              },
                              electric: {
                                padding: "15px 0px",
                                margin: "auto",
                                width: "50%",
                                color: electricColors.second,
                                cursor: "pointer",
                                float: "right",
                                textAlign: "right",
                              },
                            })}
                          >
                            {((this.props.selectedMaintenance &&
                              this.props.selectedMaintenance.status === "New" &&
                              this.checkIfAppIssue(this.props.selectedMaintenance) === false) ||
                              this.props.modalState === "Add") && (
                              <React.Fragment>
                                <span
                                  style={{
                                    verticalAlign: "top",
                                    display: "inline-block",
                                    marginRight: "10px",
                                    marginTop: "9px",
                                  }}
                                >
                                  {languageService("Is this Historical Data")}?
                                </span>
                                <span
                                  style={{ background: "var(--first)", textDecoration: "capitalize" }}
                                  onClick={this.historyDataHandler}
                                  className={"btn btn-primary"}
                                >
                                  {languageService("Yes")}
                                </span>
                              </React.Fragment>
                            )}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
              {/*{this.props.modalState === "Edit" && (*/}

              {/* <EstimateListEditable
                ml={this.props.selectedMaintenance}
                estimate={this.state.estimate}
                estimateHistoryRecord={this.state.estimateHistoryRecord}
                updateEstimate={this.updateEstimate}
                updateMaintenance={this.props.updateMaintenance}
                getMaintenance={this.props.getMaintenance}
                maintenanceActionType={this.props.maintenanceActionType}
                maintenance={this.props.maintenance}
                getApplicationlookupss={this.props.getApplicationlookupss}
                applicationlookupss={this.props.applicationlookupss}
                applicationlookupsActionType={this.props.applicationlookupsActionType}
              /> */}
              {/*)}*/}
            </Row>
          )}
          {this.state.formModes === FORM_MODES.IMAGE_SELECTION && (
            <ImageGallery
              handleSave={this.addSelectedImage}
              handleCancel={() => this.addMaintenanceStateHandler({ formModes: FORM_MODES.BASE })}
              loadImgPath={""}
              customFolder={"applicationresources"}
              uploadImageAllow
            />
          )}

          {/*{this.state.formModes === FORM_MODES.IMAGE_GALLERY && (*/}
          <ImageSlider
            imgSlider={this.state.formModes === FORM_MODES.IMAGE_GALLERY}
            imageDirectory={"applicationresources"}
            images={this.state.imageList}
            initialIndex={this.state.selectedImageIndex}
            handleToggle={this.handleImageSliderClose}
          />
          {/*)}*/}

          {this.state.formModes === FORM_MODES.DOCUMENT_SELECTION && (
            <DocumentGallery
              handleSave={this.addSelectedDocument}
              handleCancel={this.addDocumentHandle}
              loadDocumentPath={"showAssetDocuments"}
              customFolder={""}
              uploadImageAllow
            />
          )}
        </ModalBody>

        {this.state.formModes === FORM_MODES.BASE && (
          <ModalFooter style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>
            {this.props.modalState === "Add" && (
              <MyButton style={themeService(ButtonStyle.commonButton)} type="submit" onClick={this.submitForm}>
                {languageService("Add")}
              </MyButton>
            )}
            {this.props.modalState === "Edit" && (
              <MyButton style={themeService(ButtonStyle.commonButton)} onClick={this.submitForm} type="submit">
                {languageService("Update")}
              </MyButton>
            )}
            <MyButton style={themeService(ButtonStyle.commonButton)} type="button" onClick={this.props.toggle}>
              {languageService("Cancel")}
            </MyButton>
          </ModalFooter>
        )}
      </Modal>
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;
const getAsset = curdActions.getAsset;

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: { getAppMockupsTypes, getAssetLinesWithSelf, getApplicationlookupss, getAsset },
};

let variables = {
  diagnosticsReducer: {
    subdivisions: [],
  },
  assetReducer: { asset: [], assetTypes: [] },

  assetHelperReducer: {
    lineAssets: [],
  },
  applicationlookupsReducer: { applicationlookupss: [] },
};

let AddMaintenanceContainer = CRUDFunction(AddMaintenance, "addMaintenance", actionOptions, variables, [
  "assetReducer",
  "diagnosticsReducer",
  "assetHelperReducer",
  "applicationlookupsReducer",
  // 'utilReducer',
]);
export default AddMaintenanceContainer;



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenance/AddMaintenance.jsx